(function(angular) {
    THF.Angular.JoinForm.directive('tooltipster', ['$parse', function($parse) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var position = attrs.tooltipsterPosition ? attrs.tooltipsterPosition : 'top';
                    var maxWidth = attrs.tooltipsterMaxWidth ? attrs.tooltipsterMaxWidth : null;

                    element.tooltipster({
                        position: position,
                        trigger: 'click',
                        theme: 'tooltipster-default tooltipster-join',
                        content: angular.element('<div>' + scope.field.tooltip + '</div>'),
                        maxWidth: maxWidth
                    });
                }
            }
        }]);

})(angular);